import Container = PIXI.Container;
import Sprite = PIXI.Sprite;
import Text = PIXI.Text;
import TextStyle = PIXI.TextStyle;
import { createSprite } from '../../../utils/GameEngine';
import { TextStyles } from '../../../utils/TextStyles';
import { Events } from '../../../core/Events';
import { Inventory, CurrencyName, ResourceName } from '../../../core/managers/Inventory';
import { addSignal, removeAllSignals } from '../../../utils/EventUtils';
import { TextIncrement } from '../TextIncrement';

export abstract class AbstractCounter extends Container {
  protected text: TextIncrement;
  protected value: number;
  protected iconName: string;
  protected resourceName: CurrencyName | ResourceName;
  private icon: Sprite;
  private ticker: Text;

  protected constructor(parent?: PIXI.Container) {
    super();
    this.initParams();
    this.addBackground();
    this.addText();
    if (parent) {
      parent.addChild(this);
    }
    addSignal(this, Events.updatedResourceAmount, this.onAmountUpdated.bind(this));
    addSignal(this, Events.updatedResourceTicker, this.onTickerUpdated.bind(this));
  }

  protected initParams(): void {
    // override this!
  }

  protected onTickerUpdated(data: any): void {
    if (this && this.parent) {
      const resourceName: CurrencyName = data.detail.resourceName;
      const secondsLeft: number = data.detail.secondsLeft;
      const minutes: number = Math.floor(secondsLeft / 60);
      const seconds: number = secondsLeft - minutes * 60;
      let timeInMinSec: string = '';
      if (minutes > 0) {
        timeInMinSec += minutes + 'm ';
      }
      if (seconds > 0) {
        timeInMinSec += seconds + 's';
      }

      if (resourceName === this.resourceName && secondsLeft > 0) {
        if (!this.ticker) {
          this.ticker = new Text(timeInMinSec, TextStyles.verySmallTextBlack);
          this.ticker.anchor.x = 1;
          this.ticker.anchor.y = 0.5;
          this.ticker.x = this.text.x - this.text.width - 10;
          this.ticker.y = 0;
          this.addChild(this.ticker);
          if (secondsLeft < 1) {
            this.removeChild(this.ticker);
          }
        } else {
          this.addChild(this.ticker);
          this.ticker.text = timeInMinSec;
        }
      }
    }
  }

  protected onAmountUpdated(data: any): void {
    const resourceName: CurrencyName = data.detail.resourceName;
    const amount: number = data.detail.amount;
    if (resourceName === this.resourceName) {
      this.updateAmount(amount);
      if (this.ticker) {
        this.removeChild(this.ticker);
      }
    }
    if (amount === 0 && this.resourceName !== CurrencyName.Coins) {
      this.setBuyOnClick();
    } else {
      this.interactive = false;
      this.buttonMode = false;
    }
  }

  private setBuyOnClick(): void {
    this.interactive = true;
    this.buttonMode = true;
    this.on('pointerdown', (): void => {
      dispatchEvent(new CustomEvent(Events.attemptBuyBooster, {
        detail: {
          resourceName: this.resourceName
        }
      }));
      this.interactive = true;
      this.buttonMode = true;
    });
  }

  private addBackground(): void {
    this.icon = createSprite(this.iconName, this);
    this.icon.anchor.set(0.5, 0.5);
  }

  private addText(): void {
    const style: TextStyle = TextStyles.uiTextHalloween.clone();
    style.fontSize = '24px';
    style.align = 'right';
    const currentAmount: number = Inventory.getInstance().getAmount(this.resourceName);
    this.text = new TextIncrement(currentAmount, '', '', style, this, true, null, false);
    this.text.anchor.x = 1;
    this.text.anchor.y = 0.5;
    this.text.x = -this.icon.width / 2 - 10;
    this.text.y = this.icon.y - 4;
    // this.addChild(this.text);
    if (currentAmount === 0 && this.resourceName !== CurrencyName.Coins) {
      this.setBuyOnClick();
    }
  }

  public updateAmount(amount: number): void {
    if (amount > 10) {
      this.text.startSteps(amount);
    } else {
      this.text.text = amount + '';
    }
  }

  public destroy(options?: { children?: boolean; texture?: boolean; baseTexture?: boolean }): void {
    removeAllSignals(this);
    super.destroy(options);
  }
}